import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ui-inputfield',
  templateUrl: './inputfield.component.html'
})
export class InputfieldComponent {
  @Input() control: AbstractControl | null = null;
  @Input() isEditing = false;
  @Input() ngClassMap: any = {};
  @Input() customClass: string = '';
  @Output() valueChange = new EventEmitter<string>();

  onInput(): void {
    if (this.control) {
      this.valueChange.emit(this.control.value);
    }
  }
}
